import { environment } from '../../../environments/environment';

export const rolePermissions = new Map<string, string[]>([
  [
    environment.claims.systemAdmin,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PATIENT_HISTORY',
      'PROFILE',
      'SETTINGS',
      'USER_LIST',
      'VISIT_LIST',
      'MONITOR',
      'CALENDAR',
      'DEVICE_LIST',
      'ORGANIZATION_LIST',
      'ORGANIZATION_INFO',
      'ORGANIZATION_DEVICES',
      'PATIENT_REGISTRATION',
      'LOG',
      'ROUTE_MAP',
      'LABORATORY_WORK_LIST',
    ],
  ],

  [
    environment.claims.organizationAdmin,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PATIENT_HISTORY',
      'PROFILE',
      'CALENDAR',
      'USER_LIST',
      'DEVICE_LIST',
      'ORGANIZATION_DEVICES',
      'ORGANIZATION_INFO',
    ],
  ],

  [
    environment.claims.facilityAdmin,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PATIENT_HISTORY',
      'PROFILE',
      'CALENDAR',
      'USER_LIST',
      'DEVICE_LIST',
      'ORGANIZATION_DEVICES',
      'ORGANIZATION_INFO',
    ],
  ],

  [
    environment.claims.nurse,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PATIENT_HISTORY',
      'VISIT_LIST',
      'PROFILE',
      'MONITOR',
      'CALENDAR',
      'ROUTE_MAP',
    ],
  ],

  [
    environment.claims.assistant,
    ['DASHBOARD', 'VISIT_LIST', 'MONITOR', 'CALENDAR'],
  ],

  [
    environment.claims.gp,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PROFILE',
      'MONITOR',
      'CALENDAR',
      'VISIT_LIST',
    ],
  ],

  [
    environment.claims.specialist,
    [
      'DASHBOARD',
      'PATIENT_LIST',
      'PATIENT_DETAIL',
      'PATIENT_INFO',
      'PATIENT_HISTORY',
      'VISIT_LIST',
      'PROFILE',
      'MONITOR',
      'CALENDAR',
      'SPECIALIST_APPOINTMENT_CALENDAR',
      'CONSULTATION_LIST',
    ],
  ],

  [environment.claims.patient, ['PATIENT_DETAIL', 'PATIENT_HISTORY']],
]);
